export interface DeliveryOrderCounts {
  delivered: number;
  failed: number;
  pending: number;
  expired: number;
}

export function computeDeliveryCountsFromPercentages(
  totalOrders: number,
  deliveredPct: number,
  failedPct: number,
  pendingPct: number,
  expiredPct: number
): DeliveryOrderCounts {
  if (!Number.isFinite(totalOrders) || totalOrders <= 0) {
    return { delivered: 0, failed: 0, pending: 0, expired: 0 };
  }

  const raw = [
    (totalOrders * deliveredPct) / 100,
    (totalOrders * failedPct) / 100,
    (totalOrders * pendingPct) / 100,
    (totalOrders * expiredPct) / 100,
  ];

  const floors: [number, number, number, number] = [
    Math.floor(raw[0]),
    Math.floor(raw[1]),
    Math.floor(raw[2]),
    Math.floor(raw[3]),
  ];

  const fractional = [
    raw[0] - floors[0],
    raw[1] - floors[1],
    raw[2] - floors[2],
    raw[3] - floors[3],
  ];

  let remainder =
    totalOrders - floors[0] - floors[1] - floors[2] - floors[3];

  const orderByFraction = [0, 1, 2, 3].sort(
    (a, b) => fractional[b] - fractional[a]
  );

  const out: [number, number, number, number] = [...floors];

  for (let j = 0; j < remainder; j += 1) {
    const idx = orderByFraction[j % 4];
    out[idx] += 1;
  }

  return {
    delivered: out[0],
    failed: out[1],
    pending: out[2],
    expired: out[3],
  };
}
